import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";

import pre_cast_haz_lev from "../img/sswpIcons/PreCastWorks/pre_cast_haz_lev.png";
import pre_cast_exc_zon from "../img/sswpIcons/PreCastWorks/pre_cast_exc_zon.png";
import pre_cast_fix_and_anc from "../img/sswpIcons/PreCastWorks/pre_cast_works_fixing_and_anchors.jpg";
import pre_cast_del_tra from "../img/sswpIcons/PreCastWorks/pre_cast_del_tra.png";
import pre_cast_pac_pie from "../img/sswpIcons/PreCastWorks/pre_cast_pac_pie.png";
import pre_cast_sla_bea from "../img/sswpIcons/PreCastWorks/pre_cast_sla_bea.png";
import pre_cast_spr_bea from "../img/sswpIcons/PreCastWorks/pre_cast_spr_bea.png";
import pre_cast_tag_lin from "../img/sswpIcons/PreCastWorks/pre_cast_tag_lin.png";
import pre_cast_pro_typ from "../img/sswpIcons/PreCastWorks/pre_cast_pro_typ.png";
import pre_cast_anc_clu from "../img/sswpIcons/PreCastWorks/pre_cast_anc_clu.png";
import pre_cast_sit_spe_met from "../img/sswpIcons/PreCastWorks/pre_cast_sit_spe_met.png";
const json = {
    icon: pre_cast_haz_lev,
    name: "Pre-Cast",
    text: "",
    icons: {
        pre_cast_del_tra: {
            name: "Delivery/ Transport",
            icon: pre_cast_del_tra,
            text: (
                <ul>
                    <ListItem text="Deliveries should be planned to arrive on site at the correct time and in the correct order." />
                    <ListItem text="Delivery drivers need to be aware of the delivery locations, safe parking and vehicle turning arrangements. An assigned operative wearing distinctive PPE is advised to direct delivery drivers." />
                    <ListItem text="Loads should be checked prior to unloading in case any items became loose during transit." />
                    <ListItem text="Where multiple unloading are undertaken, loads must be re-secured between stopping points." />
                </ul>
            )
        },
        pre_cast_anc_clu: {
            name: "Anchors/ Clutches",
            icon: pre_cast_anc_clu,
            text: (
                <ul>
                    <ListItem text="Ensure that the correct ring clutch has been selected for the anchor and that it is used in accordance with the manufacturers requirements." />
                </ul>
            )
        },
        pre_cast_spr_bea: {
            name: "Spreader Beams",
            icon: pre_cast_spr_bea,
            text: (
                <ul>
                    <ListItem text="Spreader beams spread the lifting load across an object that is being lifted. " />
                    <ListItem text="They must be inspected and certified in accordance with all lifting gear requirements." />
                    <ListItem text="They must have a Safe Working Load marked on them, and the load being lifted cannot exceed that weight.                " />
                    <ListItem text="They should be visually inspected prior to each lift for damage/wear. Pay particular attention to attachment points." />
                </ul>
            )
        },
        pre_cast_pac_pie: {
            name: "Packing Pieces",
            icon: pre_cast_pac_pie,
            text: (
                <ul>
                    <ListItem text="When lifting objects place suitable packing material around sharp edges to prevent damage to the lifting gear (straps or chains etc)." />
                </ul>
            )
        },
        pre_cast_tag_lin: {
            name: "Tag Lines",
            icon: pre_cast_tag_lin,
            text: (
                <ul>
                    <ListItem text="When Long loads (e.g. beams, steel sections etc) are lifted, CSCS Slinger Signallers should attach a rope, or tag line, to one or both ends to control rotational movement." />
                    <ListItem text="The orientation of the load is controlled during the lift, as well as at the landing." />
                </ul>
            )
        },
        pre_cast_exc_zon: {
            name: "Exclusion Zone",
            icon: pre_cast_exc_zon,
            text: (
                <ul>
                    <ListItem text="Operatives should not work under an area where loads are being lifted or within the working radii of a job." />
                    <ListItem text="Operatives should keep a safe distance from working plant (at least 2 machine lengths at any time)." />
                    <ol>
                        <Typography variant="title">
                            Operatives on foot must clearly know where such
                            zones are and how they are demarked
                        </Typography>
                        <ListItem text="Barriers" />
                        <ListItem text="Markings/ Signage" />
                        <ListItem text="Method of Work" />
                    </ol>
                </ul>
            )
        },
        pre_cast_fix_anc: {
            name: "Fixings & Anchors",
            icon: pre_cast_fix_and_anc,
            text: (
                <ul>
                    <ListItem text="These must be fitted as per the manufacturers specification including specified brackets and bolts." />
                    <ListItem text="Bolts must be required size, strength and placed at the specified depth." />
                    <ListItem text="Bolts must be placed at the required spacings in the correct manner." />
                </ul>
            )
        },
        pre_cast_sla_bea: {
            name: "Slab Bearings",
            icon: pre_cast_sla_bea,
            text: (
                <ul>
                    <ListItem text="Slab bearing details should be prescribed by the manufacturer, designer or engineer. You must follow their specification." />
                    <ListItem text="The bearing point for slabs must be stable, and strong enough for the carried weight. The slab cannot be allowed to move after it is placed." />
                    <ListItem text="Temporary propping may be required, until such time as all the necessary reinforcement has been placed at the slab bearing points." />
                </ul>
            )
        },
        pre_cast_pro_typ: {
            name: "Propping Type",
            icon: pre_cast_pro_typ,
            text: (
                <ul>
                    <ListItem text="Can be used to support formwork or to support large steel or concrete components." />
                    <ListItem text="Must be selected by competent structural engineer." />
                    <ListItem text="Proprietary propping systems should not be mixed in the one application" />
                </ul>
            )
        },
        pre_cast_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: pre_cast_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
